module.exports = __webpack_public_path__ + "static/media/calendar_31.f3fec1f0.png";